<div
    class="relative flex flex-col h-full max-h-full bg-white transition-all duration-200 ease-in-out w-full box-border overflow-hidden">
    <div class="flex-1 flex flex-col overflow-auto min-h-0 bg-white box-border">
        <div class="flex flex-col h-full">
            @if(isLoading()) {
            <div class="flex-1 p-4 overflow-auto">
                <div class="space-y-4">
                    <p-skeleton width="8rem" height="2rem"></p-skeleton>
                    <p-skeleton width="100%" height="5rem" styleClass="rounded-md"></p-skeleton>
                    <p-skeleton width="100%" height="10rem" styleClass="rounded-md"></p-skeleton>
                    <p-skeleton width="100%" height="5rem" styleClass="rounded-md"></p-skeleton>
                </div>
            </div>
            }
            @else if(!toolCall()) {
            <div class="flex flex-col items-center justify-center flex-1 p-8">
                <div class="flex flex-col items-center space-y-4 max-w-sm text-center">
                    <div class="relative">
                        <div class="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center">
                            <app-icon [type]="'computer'" [class]="'h-8 w-8 text-zinc-400'" [source]="'lucide'"
                                [size]="'lg'"></app-icon>
                        </div>
                        <div
                            class="absolute -bottom-1 -right-1 w-6 h-6 bg-zinc-200 rounded-full flex items-center justify-center">
                            <div class="w-2 h-2 bg-zinc-400 rounded-full"></div>
                        </div>
                    </div>
                    <div class="space-y-2">
                        <h3 class="text-lg font-medium text-zinc-900">
                            No tool activity
                        </h3>
                        <p class="text-sm text-zinc-500 leading-relaxed">
                            Tool calls and computer interactions will appear here when they're being executed.
                        </p>
                    </div>
                </div>
            </div>
            }
            @else {
            <div class="flex-1 overflow-hidden">
                <app-tool-view [toolCall]="toolCall()!"></app-tool-view>
            </div>
            }
        </div>
    </div>

</div>
